module.exports = __webpack_public_path__ + "img/tp2.0c8a74bd.png";